module.exports = __webpack_public_path__ + "img/colonial-wire-cable-co-autoscroll.61067777.png";